import axios from 'util/axiosConfig';
import { getErrorMessage } from '../util/ErrorUtils';

export const getMipsAPI = async (payload) => {
    const params = {
        ...payload,
        pageNo: payload.pageNo ? payload.pageNo - 1 : 0
    };
    return await axios.get(`/api/v1/admin/mips`, {
        params
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, mip: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getMipsFilterAPI = async (payload) => {
    const params = {
        ...payload,
        pageNo: payload.pageNo ? payload.pageNo - 1 : 0
    };
    return await axios.get(`/api/v1/admin/mips`, {
        params
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, mip: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const addUpdateMipAPI = async (mip) => {
    return await axios.post(`/api/v1/admin/add-update-mip`, mip)
        .then(function (response) {
            if (response.data) {
                return { success: true, mip: response.data };
            } else {
                return { success: false, error: response.message };
            }
        })
        .catch(function (error) {
            if (error && error.response && error.response.data) {
                return { success: false, error: error.response.data.message };
            }
            return { success: false, error };
        });
}

export const fetchAllMipMachinesAPI = async (mipId) => {
    return await axios.get(`/api/v1/mips/${mipId}/machines`, {
        params: {
            mipId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, mipMachines: response.data };
            } else {
                return { success: false, error: response.message };
            }
        })
        .catch(function (error) {
            if (error && error.response && error.response.data) {
                return { success: false, error: error.response.data.message };
            }
            return { success: false, error };
        });
}

export const addUpdateMipMachineAPI = async (machine) => {
    return await axios.post(`/api/v1/mips/${machine.mipId}/machine`, machine)
        .then(function (response) {
            if (response.data) {
                return { success: true, mipMachine: response.data };
            } else {
                return { success: false, error: response.message };
            }
        })
        .catch(function (error) {
            if (error && error.response && error.response.data) {
                return { success: false, error: error.response.data.message };
            }
            return { success: false, error };
        });
}


export const deleteMipMachineAPI = async (data) => {
    return await axios.delete(`/api/v1/mips/${data.mipId}/machines/${data.machineId}`, {
        params: {
            ...data
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: response.message };
            }
        })
        .catch(function (error) {
            if (error && error.response && error.response.data) {
                return { success: false, error: error.response.data.message };
            }
            return { success: false, error };
        });
}